import {
  Slider,
  SliderFilledTrack,
  SliderMark,
  SliderThumb,
  SliderTrack,
} from '@chakra-ui/react';
import React, { useState } from 'react';

import {
  INTEREST,
  MIN_INTEREST,
} from '@/constants/payment-method/payment.constants';
import { FinanceParts } from '@/types/filters/filters.types';
import { SliderMarks } from '@/types/used-cars/used-cars.types';

import { BalloonOptions } from '../balloon-options/balloon-options';
import { PriceInput } from '../price-input/price-input';
import { SectionName } from '../section-name/section-name';

import styles from './payment-method.module.scss';

export const PaymentMethod: React.FC<{
  methodName: string;
  prefix: string;
  value: number;
  onValueChange: (arg: number, name: string) => void;
  onSliderChange: (arg: number, name: string) => void;
  sliderStep: number;
  marks: Record<string, SliderMarks>;
  max: number;
  name: string;
}> = ({
  methodName,
  prefix,
  value,
  onValueChange,
  onSliderChange,
  sliderStep,
  marks,
  max,
  name,
}) => {
  const [savedValue, setSavedValue] = useState(0);

  return (
    <div className={styles.paymentMethodWrapper}>
      <div className={styles.sectionWrapper}>
        <SectionName>{methodName}</SectionName>
        <div className={styles.flex}>
          {FinanceParts.balloon === name && (
            <BalloonOptions
              savedValue={savedValue}
              name={name}
              onValueChange={onValueChange}
            />
          )}
          <PriceInput
            prefix={prefix}
            value={value}
            onChange={(value) => {
              onValueChange(value || 0, name);
              if (methodName == 'Balloon Payment') {
                setSavedValue(value);
              }
            }}
            name={name}
            step={sliderStep}
          />
        </div>
      </div>

      <Slider
        mb={4}
        step={sliderStep}
        max={max}
        value={value}
        onChange={(value) => {
          if (name == INTEREST && value < MIN_INTEREST) {
            return MIN_INTEREST;
          } else {
            onSliderChange(value || 0, name);
            if (methodName == 'Balloon Payment') {
              setSavedValue(value);
            }
          }
        }}
      >
        <SliderTrack bg="gray.100">
          <SliderFilledTrack bg="black" />
        </SliderTrack>
        <SliderThumb boxSize={6} borderWidth="1px" borderColor="black" />
        <SliderMark value={0} textAlign="left" mt={4}>
          {marks[0]?.label}
        </SliderMark>
        <SliderMark
          value={max}
          textAlign="right"
          width="max-content"
          transform="translateX(-100%)"
          mt={4}
        >
          {marks[max]?.label}
        </SliderMark>
      </Slider>
    </div>
  );
};
